import { useIsMobilePhone } from '@/composables/useIsMobilePhone';
import { useMobilePreferenceStore } from '@/core/shared/mobile-preference/mobile-preference.store';

// "Show full version" is a per-session escape hatch on phones: every full page
// load on a phone resets the persisted preference back to mobile. Called once
// from App.vue and deliberately not reactive, so resizing or in-app navigation
// never yanks the user out of a desktop view they chose during the session.
export function useMobileViewModeBootReset(): void {
  const isMobilePhone = useIsMobilePhone();
  const mobilePreferenceStore = useMobilePreferenceStore();

  if (isMobilePhone.value) {
    mobilePreferenceStore.setPreferredViewMode('mobile');
  }
}
